module.exports = __webpack_public_path__ + "img/icon_submenu18.c655293b.svg";